/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function r(r,t){if(!Array.isArray(t))return!1;const n=t.length;if(n!==r.length)return!1;for(let e=0;e<n;e++)if(t[e]!==r[e])return!1;return!0}export{r as shallowCompare};
//# sourceMappingURL=shallow-compare.js.map
